import { compose, createStore, applyMiddleware, combineReducers } from 'redux'
import thunkMiddleWare from 'redux-thunk'

import * as reducers from './modules'

// eslint-disable-next-line no-underscore-dangle
const devtoolExtension = () => (typeof global !== 'undefined' && global.__REDUX_DEVTOOLS_EXTENSION__ ? global.__REDUX_DEVTOOLS_EXTENSION__() : x => x)

const createEnhancer = () =>
  compose(
    applyMiddleware(thunkMiddleWare),
    devtoolExtension(),
  )

export default initialState => {
  const store = createStore(combineReducers(reducers), initialState, createEnhancer())

  return store
}
